import { render, staticRenderFns } from "./target_link.vue?vue&type=template&id=59f1e4ce"
import script from "./target_link.vue?vue&type=script&lang=js"
export * from "./target_link.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports